import { useSelector } from 'react-redux';

import { SectionCodes } from 'const';
import {
  IEntryFormEntityProperties,
  IPortfolioEntryFormData,
  MappedEventData,
} from 'portfolio3/features/dataEntryForm';
import { IRootState } from 'reducers';
import { getCategoryProperties } from 'utils';

import { getCommonEventProperties, getCommonOccupationProperties, getCommonRewardProperties } from './utils';

interface IProps {
  formData: IPortfolioEntryFormData;
  mappedEventData: MappedEventData;
}

const useScienceEntityProperties = ({ formData, mappedEventData }: IProps): IEntryFormEntityProperties | null => {
  const portfolioSections = useSelector((state: IRootState) => state.sectionRef.content);
  const rewards = useSelector((state: IRootState) => state.rewardKinds.content);

  const categoryCode = formData.categoryCode;
  const dataKind = formData.dataKind;

  const categoryProperties = categoryCode ? getCategoryProperties(categoryCode) : null;

  let name: string | undefined;
  let typeName: string | undefined;
  let attributes: string[] | undefined;

  if (dataKind === SectionCodes.project) {
    name = portfolioSections.find((section) => section.code === dataKind)?.value;
    typeName = 'Проект';
  }

  if (dataKind === SectionCodes.scienceOccupation) {
    const props = getCommonOccupationProperties(portfolioSections, formData);
    name = props.name;
    typeName = props.typeName;
    attributes = props.attributes;
  }

  if (dataKind === SectionCodes.scienceEvent) {
    const props = getCommonEventProperties(mappedEventData);
    name = props.name ?? 'Конкурс';
    typeName = props.typeName;
    attributes = props.attributes;
  }

  if (dataKind === SectionCodes.scienceReward) {
    const props = getCommonRewardProperties(rewards, portfolioSections, formData);
    name = props.name;
    typeName = props.typeName;
    attributes = props.attributes;
  }

  if (categoryCode !== SectionCodes.science) return null;

  return {
    entityInfo: {
      name,
      categoryName: categoryProperties?.name ?? '',
      typeName: typeName ?? '',
      attributes,
    },
  };
};

export default useScienceEntityProperties;
